import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { IntegrationTypeCardWebComponentSchema } from '../types';
import { WEB_COMPONENT_GZ_CARD, WEB_COMPONENT_GZ_INFO_BOX } from '../../../webcomponents.constants';
import { elementClassListAdd, toggleVisibility } from '../../../utils/htmlElement.utils';
import { LicenseStatus } from '../../../license/types/LicenseStatus';

import moment from 'moment-timezone';

export class IntegrationTypeCardView extends BaseWebComponentView {
  getDomElements() {
    this.dom.$wrapper = this.shadow.querySelector('.wrapper');

    this.dom.$gzCard = this.shadow.querySelector(WEB_COMPONENT_GZ_CARD);
    this.dom.$licenseStatus = this.shadow.querySelector('#license-status-label');
    this.dom.$licenseExpire = this.shadow.querySelector('#license-expire-label');
    this.dom.$licenseTitle = this.shadow.querySelector('#license-title');
    this.dom.$cardDescription = this.shadow.querySelector('.card-description');
    this.dom.$cardIntegrationType = this.shadow.querySelector('.card-integration-type');
    this.dom.$integrateButton = this.shadow.querySelector('#integrate-button');
    this.dom.$requirementsButton = this.shadow.querySelector('#requirements-button');
    this.dom.$cardLicenseActive = this.shadow.querySelector('.card-license-active');

    this.dom.$cardLicenseNotActive = this.shadow.querySelector('.card-license-not-active');
    this.dom.$cardLicenseStatus = this.shadow.querySelector('#card-license-status');
    this.dom.$addLicenseButton = this.shadow.querySelector('#add-license-button');
    this.dom.$contactAdministratorBox = this.shadow.querySelector(WEB_COMPONENT_GZ_INFO_BOX);
  }

  buildSuccessView(data: IntegrationTypeCardWebComponentSchema) {
    this.dom.$gzCard.name = data.name;
    this.dom.$cardDescription.innerText = data.description;
    this.dom.$cardIntegrationType.innerText = data.integrationType;

    if (!data.license) {
      this.setLicenseStateBasedOnStatus('bullet-neutral', this.dependencies.translateFn('Not licensed'));
      return;
    }

    if (data.license.status === LicenseStatus.EXPIRED) {
      this.setLicenseStateBasedOnStatus('bullet-danger', this.dependencies.translateFn('Not licensed'));
      return;
    }

    if (data.license.status === LicenseStatus.INVALID) {
      this.setLicenseStateBasedOnStatus('bullet-danger', this.dependencies.translateFn('License invalid'));
      return;
    }

    if (data.license.status === LicenseStatus.ACTIVE) {
      this.setActiveLicenseState(data);
    }
  }

  setActiveLicenseState(data) {
    toggleVisibility(this.dom.$cardLicenseNotActive, false);
    toggleVisibility(this.dom.$cardLicenseActive, true);
    toggleVisibility(this.dom.$integrateButton, !data.nonUserConfigurable);
    toggleVisibility(this.dom.$requirementsButton, data.nonUserConfigurable);
    this.dom.$licenseTitle.innerText = this.dependencies.translateFn('License');
    this.dom.$licenseExpire.innerText = moment(data.license.expiryDate).format('DD/MM/YYYY');
    this.dom.$licenseExpire.label = this.dependencies.translateFn('Expires');
    this.dom.$licenseStatus.label = this.dependencies.translateFn('Status');
    this.dom.$integrateButton.innerText = this.dependencies.translateFn('Integrate');
    this.dom.$requirementsButton.innerText = this.dependencies.translateFn('Requirements');

    this.dom.$licenseStatus.innerHTML = `<span class="cell-label has-bullet bullet-success">${this.dependencies.translateFn(
      'Active'
    )}</span>`;
  }

  setLicenseStateBasedOnStatus(bulletClass, statusText) {
    toggleVisibility(this.dom.$cardLicenseActive, false);
    toggleVisibility(this.dom.$cardLicenseNotActive, true);
    elementClassListAdd(this.dom.$cardLicenseStatus, bulletClass);
    this.dom.$cardLicenseStatus.innerText = statusText;

    if (this.dependencies.Ext.userHasRight('companyManager')) {
      const canAddLicense = this.dependencies.Ext.canAddLicense(this.dependencies.getActiveCompany().companyId);
      toggleVisibility(this.dom.$addLicenseButton, canAddLicense);
      toggleVisibility(this.dom.$contactAdministratorBox, !canAddLicense);
      this.dom.$contactAdministratorBox.innerText = this.dependencies.translateFn('Please contact your administrator');
      this.dom.$addLicenseButton.innerText = this.dependencies.translateFn('Add License');
    } else {
      toggleVisibility(this.dom.$contactAdministratorBox, true);
      this.dom.$contactAdministratorBox.innerText = this.dependencies.translateFn('Please contact your administrator');
    }
  }
}
